export const selectGeolocation = state => state?.settings?.geoLocation
